import { inject, Pipe, PipeTransform } from '@angular/core';
import { OnlyVisibleTableCollectionActionsService } from '../services/only-visible-table-collection-actions.service';
import { Nillable } from '@web/utils';
import { TableCollectionAction } from '../models/table-collection-action';
import { TableRowsSelection } from '../models/table-rows-selection';

@Pipe({
  name: 'onlyVisibleTableCollectionActions',
  standalone: true,
})
export class OnlyVisibleTableCollectionActionsPipe<
  Item,
  Filter,
  CollectionAction,
> implements PipeTransform {
  private readonly onlyVisibleTableCollectionActions = inject<
    OnlyVisibleTableCollectionActionsService<Item, Filter, CollectionAction>
  >(OnlyVisibleTableCollectionActionsService);

  public transform(
    actions: Nillable<
      Array<TableCollectionAction<Item, Filter, CollectionAction>>
    >,
    selection: Nillable<TableRowsSelection<Item, Filter>>,
  ): Nillable<Array<TableCollectionAction<Item, Filter, CollectionAction>>> {
    return this.onlyVisibleTableCollectionActions.resolveVisibility(
      actions,
      selection,
    );
  }
}
